import * as traversal from '../../utilities/traversal';
import getHtmlParam from '../../utilities/htmlParam';
import { windowLoaded } from '../../utilities/domready';
import { toCart } from './tocart';

export class OrderedTogether {

    private param: Map<any, any>;

    handleCheckboxes(section: HTMLElement) {
        const items = [].slice.call(section.querySelectorAll('.item-orderedTogether'));
        const checkboxes = [].slice.call(section.querySelectorAll('.item-orderedTogether input[name^="article-ordered-together-"]'));
        const sumElement: HTMLElement = section.querySelector('.reco-orderedTogether-total');
        const that = this;

        function calculateSum() {
            let checkedBoxes:Array<number> = [];

            checkboxes.forEach((checkbox: HTMLInputElement) => {
                if(checkbox.checked) {
                    checkedBoxes.push(parseInt(checkbox.dataset.articleId));
                }
            })

            return window.fetch('/order/cart/simulateCartPrice?articleIds=' + String(checkedBoxes));
        }

        if(typeof checkboxes !== 'undefined') {
            checkboxes.forEach((checkbox: HTMLInputElement) => {
                checkbox.addEventListener('change', () => {

                    calculateSum()
                        .then(data => data.json())
                        .then(response => {sumElement.innerHTML = response.cartSummaryModel.itemTotalFormatted})
                        .catch(err => {console.log(err)});
                });
            });
        }

        calculateSum().then(data => data.json())
            .then(response => {sumElement.innerHTML = response.cartSummaryModel.itemTotalFormatted})
            .catch(err => {console.log(err)});
    }

    handleAddToCart(section: HTMLElement) {

        const addToCartButton: HTMLButtonElement = section.querySelector('.toggle-orderedTogether-to-basket');

        addToCartButton && addToCartButton.addEventListener('click', () => {

            new toCart().addMultipleToBasket(addToCartButton, 'PDS_CartAdd_orderedTogether');

        });
    }

    init() {
        windowLoaded(() => {
            this.param = getHtmlParam('.js-param .param');
            if (document.querySelector('.reco-orderedTogether.v3')) {
                const section: HTMLElement = document.querySelector('.reco-orderedTogether.v3')
                this.handleCheckboxes(section);
                this.handleAddToCart(section);
            }
        });
    }
}